import TicketRequest from './components/TicketRequest.css';
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs.css';
import Status from './components/Status/Status.css';

export default {
	TicketRequest,
	Breadcrumbs,
	Status
};
